<style type="text/scss" lang="scss">
  .notifications {
    position: fixed;
    right: 0;
    top: 0;

    width: 100%;
    height: 100%;
    pointer-events: none;
    z-index: 99999;
  }

  .notifications.active {
    pointer-events: all;
  }

  .notification {
    background: #fff;
    border-radius: 4px;
    box-shadow: -1px 0 62px -6px rgba(0, 0, 0, 0.35);
    font-family: proxima-nova, sans-serif;
    font-weight: 500;
    font-size: 16px;
    padding: 16px;
    color: #4c4c4b;
    display: flex;
    align-items: center;
  }

  .button {
    border-radius: 4px;
    padding: 12px 12px;
    font-family: proxima-nova, sans-serif;
    font-size: 12px;
    font-weight: 700;
    maring-bottom:0;
  }

  .buttons {
    margin: 16px 0;
  }

  .confirm {
    background: #4bb543;
  }

  .cancel {
    background: #4e4e4e;
  }

  .notification img {
    width: 100%;
  }

  .notification-bg {
    width: 100%;
    height: 100%;
    transition: background 0.3s;
  }

  .active .notification-bg {
    background: rgba(255, 255, 255, 0.65);
  }

  .notification-list {
    width: 400px;
    height: 100%;
    right: 0;
    top: 0;
    padding: 16px;
    position: absolute;
  }
</style>

<script>
  import { fade, fly } from 'svelte/transition';
  import { notifications } from './notifications.store';

  let active;
  let list;

  const unsubscribe = notifications.subscribe(value => {
    active = value.length > 0;
    list = value;
  });

  function cancel() {
    console.log('cancel');
    notifications.update(() => []);
  }

  function confirm(notification) {
    notifications.update(() => []);
    notification.confirm();
  }
</script>

<div class="notifications" class:active>
  <div class="notification-bg">
    <div class="notification-list">
      {#each list as notification (notification.id)}
      <div
        in:fly="{{ y: 50, duration: 500, delay: 300 }}"
        out:fly="{{ y: -100, duration: 300 }}"
        class="notification {notification.type}"
      >
        <div class="grid-x grid-margin-x">
          <div class="cell small-2">
            <img src="{notification.icon}" />
          </div>
          <div class="cell small-10">
            <span>{notification.message}</span>
          </div>
          {#if notification.confirm}
          <div class="cell small-12 text-right">
            <div class="buttons">
              <div on:click={() => notification.confirm(notification)} class="button confirm">
                Yes
              </div>
              <div on:click="{cancel}" class="button cancel">
                Cancel
              </div>
            </div>
          </div>
          {/if}
        </div>
      </div>
      {/each}
    </div>
  </div>
</div>
